import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app/directives/shared.module";
import { c_dtable_mp_session_code_settings_component } from "./c_dtable_mp_session_code_settingscomponent";

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  declarations: [c_dtable_mp_session_code_settings_component],
  exports: [c_dtable_mp_session_code_settings_component],
})
export class c_dtable_mp_session_code_settings_module {}
